import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap/dist/css/bootstrap.min.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import {
  createTheme,
  responsiveFontSizes,
  ThemeProvider,
} from "@mui/material/styles";
import { Provider } from "react-redux";
import { store } from "./app/store";

let theme = createTheme({
  typography: {
    h1: {
      fontFamily: "Red Hat Display, sans-serif",
      color: "#000",
    },
    h2: {
      fontFamily: "Red Hat Display, sans-serif",
      color: "#000",
    },
    h3: {
      fontFamily: "Red Hat Display, sans-serif",
      color: "#000",
    },
    h4: {
      fontFamily: "Red Hat Display, sans-serif",
      color: "#000",
    },
    h5: {
      fontFamily: "Red Hat Display, sans-serif",
      color: "#000",
    },
    h6: {
      fontFamily: "Red Hat Display, sans-serif",
      color: "#000",
    },
    subtitle1: {
      fontFamily: "Red Hat Display, Arial",
      color: "#5D5D5D",
    },
    subtitle2: {
      fontFamily: "Red Hat Display, Arial",
      color: "#5D5D5D",
    },
    body1: {
      fontFamily: "Red Hat Display, Arial",
    },
    body2: {
      fontFamily: "Red Hat Display, Arial",
    },
    button: {
      fontFamily: "Red Hat Display, Arial",
    },
    caption: {
      fontFamily: "Red Hat Display, Arial",
    },
    overline: {
      fontFamily: "Red Hat Display, Arial",
    },
  },
});
theme = responsiveFontSizes(theme);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Provider store={store}>
        <ThemeProvider theme={theme}>
          <App />
        </ThemeProvider>
      </Provider>
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
